var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiMedal20Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    part: "icon",
    id: "mi-medal",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.768 2.336A1 1 0 0 1 5.71 1h8.58a1 1 0 0 1 .942 1.336L13.23 7.943a6 6 0 1 1-6.46 0L4.768 2.336zm2.896 5.136A5.968 5.968 0 0 1 9.5 7.021V2H5.71l1.954 5.472zM10.5 2v5.02c.646.054 1.264.21 1.836.452L14.29 2H10.5zM10 8a4.999 4.999 0 0 0-5 5 5 5 0 1 0 5-5zm0 1a.5.5 0 0 1 .464.314l.874 2.186H13.5a.5.5 0 0 1 .3.9l-1.72 1.29.649 2.166a.5.5 0 0 1-.756.56L10 15.101l-1.973 1.315a.5.5 0 0 1-.756-.56l.65-2.165L6.2 12.4a.5.5 0 0 1 .3-.9h2.161l.875-2.186A.5.5 0 0 1 10 9zm0 1.846L9.339 12.5H8l1.08.81-.452 1.504L10 13.899l1.372.915-.451-1.505L12 12.5h-1.338L10 10.846z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiMedal20Px);
export default __webpack_public_path__ + "static/media/mi-medal-20px.85358d897c40b253a64b208565d93bde.svg";
export { ForwardRef as ReactComponent };